import { isValidEmailAddress, fadeOutNotifications, QueryString } from '../functions';
import Swal from 'sweetalert2';

$(document).ready(function() {

	const searchWidget = {
        isLoading: false,
		dateToChagend: false,
        init() {
			const _this = this;

            $(document).on('click', '.check-availability-btn', this, this.checkAvailability);
            $(document).on('change', '#return_to_other_location', this, this.returnToOtherLocation);
			$(document).on('change', '#pickup_location', function() {
				_this.displayLocationSchedule(this, true);
			});
			$(document).on('change', '#return_location', function() {
				_this.displayLocationSchedule(this, false);
			});
            $(document).on('click', '.select-from-time', this, this.selectFromTime);
            $(document).on('click', '.select-to-time', this, this.selectToTime);

			$('#pickup_location').select2({
				minimumResultsForSearch: -1
			});
			$('#return_location').select2({
				// minimumResultsForSearch: -1
			});

			$('#date-from').daterangepicker({
				//opens: 'left',
		        //alwaysShowCalendars: true,
				minDate: moment().add(2, 'hours'),
				//minDate: moment().add(1, 'days'),
				// startDate: moment().add(1, 'days'),
				// endDate: moment().add(3, 'days'),
				autoApply: true,
				autoUpdateInput: true,
				singleDatePicker: true,
				locale: {
					format: 'DD/MM/YYYY'
				}
			});
			$('#date-to').daterangepicker({
				//opens: 'left',
				//alwaysShowCalendars: true,
				minDate: moment().add(2, 'hours'),
				//minDate: moment().add(1, 'days'),
				// startDate: moment().add(1, 'days'),
				// endDate: moment().add(3, 'days'),
				autoApply: true,
				autoUpdateInput: true,
				singleDatePicker: true,
				locale: {
					format: 'DD/MM/YYYY'
				}
			});
			$('.drp-calendar.right').show();

			$('#date-to').on('apply.daterangepicker', function(ev, picker) {
				_this.dateToChagend = true;
			});

			$('#date-from').on('apply.daterangepicker', function(ev, picker) {
				var startDate = picker.startDate;
				var endDate = picker.endDate;
				
				if (!_this.dateToChagend) {
					startDate.add('3', 'days');
					$('#date-to').val(startDate.format('DD/MM/YYYY'));
					$('#date-to').data('daterangepicker').setStartDate(startDate);
				}

				// $('#date-from').val(startDate.format('DD/MM/YYYY'));
				// $('#date-to').val(endDate.format('DD/MM/YYYY'));

				// $('#date-from-text').html(startDate.format('dddd, D MMM'));
				// $('#date-to-text').html(endDate.format('dddd, D MMM'));

				// $('#search-calendar-trigger').html(startDate.format('ddd, D MMM') + ' | ' +endDate.format('ddd, D MMM'));
			});
        },
		displayLocationSchedule(element, isPickup) {
			const _this = this;
			const noLocaitonText = $('.pickup-location-schedule-container').data('text');
			const scheduleContainer = isPickup ? '.pickup-location-schedule-container' : '.return-location-schedule-container';
			const returnScheduleContainer = '.return-location-schedule-container';
			const mirrorReturnSchedule = isPickup && !$('#return_to_other_location').is(":checked");
			let schedule = $(element).find('option:selected').data('schedule');

			if ($(element).val() == '') {
				$(scheduleContainer).text(noLocaitonText);
				if (mirrorReturnSchedule) {
					$(returnScheduleContainer).text(noLocaitonText);
				}
				return;
			}

			if (!$('#return_to_other_location').is(":checked")) {
			}

			if (typeof schedule === 'string') {
				try {
					schedule = JSON.parse(schedule);
				} catch (error) {
					schedule = null;
				}
			}

			const allWeekSchedule = Array.isArray(schedule)
				? schedule.find((item) => Number(item.all_week) === 1)
				: null;
			const trimSeconds = (value) => (value ? value.slice(0, 5) : '');

			if (allWeekSchedule && allWeekSchedule.open_time && allWeekSchedule.close_time) {
				const scheduleText = `${trimSeconds(allWeekSchedule.open_time)} - ${trimSeconds(allWeekSchedule.close_time)}`;
				$(scheduleContainer).text(scheduleText);
				if (mirrorReturnSchedule) {
					$(returnScheduleContainer).text(scheduleText);
				}
				return;
			}

			if (Array.isArray(schedule) && schedule.length > 0) {
				const dayLines = schedule
					.filter((item) => Number(item.all_week) !== 1 && item.open_time && item.close_time)
					.sort((a, b) => Number(a.day) - Number(b.day))
					.map((item) => {
						const dayLabel = moment().isoWeekday(Number(item.day)).format('ddd');
						const timeRange = `${trimSeconds(item.open_time)} - ${trimSeconds(item.close_time)}`;
						return `${dayLabel}: ${timeRange}`;
					});
				if (dayLines.length > 0) {
					const scheduleHtml = dayLines.join('<br>');
					$(scheduleContainer).html(scheduleHtml);
					if (mirrorReturnSchedule) {
						$(returnScheduleContainer).html(scheduleHtml);
					}
					return;
				}
			}

			$(scheduleContainer).text('-');
			if (mirrorReturnSchedule) {
				$(returnScheduleContainer).text('-');
			}

		},
		selectFromTime(event) {
			const _this = event.data;
			event.preventDefault();

			$(this).parent().parent().find('li').removeClass('active');
			$(this).parent().addClass('active');

			const time = $(this).data('time');
			$('#from-time').val(time);
			$('#from-time-label').text(time);
		},
		selectToTime(event) {
			const _this = event.data;
			event.preventDefault();

			$(this).parent().parent().find('li').removeClass('active');
			$(this).parent().addClass('active');

			const time = $(this).data('time');
			$('#to-time').val(time);
			$('#to-time-label').text(time);
		},
		returnToOtherLocation(event) {
			const _this = event.data;

			if ($(this).is(":checked")) {
				$('#return-to-other-location-cointainer').hide();
				$('#return-location-cointainer').show();
			} else {
				$('#return-location-cointainer').hide();
				$('#return-to-other-location-cointainer').show();
			}
		},
		checkAvailability(event) {
			const _this = event.data;
			let url = $(this).data('url');
			if (!url || url == '' || url == null) {
				console.error('Invalid URL!');
				return false;
			}

			if ($('#pickup_location').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#pickup_location').data('alert')
				});
				return;
			}
			if ($('#return_to_other_location').is(':checked')) {
				if ($('#return_location').val() == '') {
					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: $('#return_location').data('alert')
					})
					return;
				}
			}
			if ($('#date-from').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#date-from').data('alert')
				});
				return false;
			}
			if ($('#date-to').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#date-to').data('alert')
				});
				return false;
			}
			if ($('#from-time').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#from-time').data('alert')
				});
				return false;
			}
			if ($('#to-time').val() == '') {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: $('#to-time').data('alert')
				});
				return false;
			}

			if (typeof LONGTERM_RESERVATION_THRESHOLD !== 'undefined' && LONGTERM_RESERVATION_THRESHOLD > 0) {
				const pickupDate = moment($('#date-from').val(), 'DD/MM/YYYY');
				const returnDate = moment($('#date-to').val(), 'DD/MM/YYYY');
				if (returnDate.diff(pickupDate, 'days') > LONGTERM_RESERVATION_THRESHOLD) {
					Swal.fire({
						text: LONGTERM_RESERVATION_THRESHOLD_MESSAGE,
						confirmButtonText: LONGTERM_RESERVATION_THRESHOLD_BUTTON_LABEL
					}).then((result) => {
						if (result.isConfirmed) {
							window.location.href = LONGTERM_PAGE_URL;
						}
					});
					return false;
				}
			}

			let genUrl = '?pl=' + $('#pickup_location').val();
			if ($('#return_to_other_location').is(':checked')) {
				genUrl += '&rol=1';
				genUrl += '&rl=' + $('#return_location').val();
			} else {
				genUrl += '&rl=' + $('#pickup_location').val();
			}
			genUrl += '&pd=' + $('#date-from').val() + '-' + $('#from-time').val();
			genUrl += '&rd=' + $('#date-to').val() + '-' + $('#to-time').val();
			if ($('#driver-age').is(':checked')) {
				genUrl += '&da=' + $('#driver-age').val();
			}
			if ($('#travel-abroad').is(':checked')) {
				genUrl += '&ta=1';
			}
			if ($('#pet-friendly').is(':checked')) {
				genUrl += '&pf=1';
			}

			if ($(this).data('source') == 'group-page' || $(this).data('source') == 'select-extras-page' || $(this).data('source') == 'reservation') {
				genUrl += '&group=' + $(this).data('group');
			}
			if ($(this).data('source') == 'select-extras-page' && QueryString(null).insurance != '') {
				genUrl += '&insurance=' + QueryString(null).insurance;
			}
			if ($(this).data('source') == 'reservation') {
				if(QueryString(null).insurance) {
					genUrl += '&insurance=' + QueryString(null).insurance;
				}
				if(QueryString(null).extras) {
					genUrl += '&extras=' + QueryString(null).extras;
				}
			}

			if ($(this).data('aff-id') && $(this).data('aff-id') != '') {
				genUrl += '&aff=' + $(this).data('aff-id');
			}

			if ($(this).data('affiliate') == '1') {
				window.open(url + genUrl);
			} else {
				window.location = url + genUrl;
			}
		}
    };

    if ($('.search-widget').length) {
        searchWidget.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/search-widget.js